import React from "react";
import "../Navigation/css/NavBar.scss";

export default function URLPaths() {
    return (
        <div>
            URL Paths
        </div>
    )
}